/* ReviewsContainerV2.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["marginTop"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _19 = "._4cvr1h6o{align-items:center}";
const _18 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _17 = "._19pkxncg{margin-top:var(--ds-space-800,4pc)}";
const _16 = "._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}";
const _15 = "@media not all and (min-width:64rem){._uoz5uufb{grid-column:span 12}._3wvkidpf{margin-top:0}}";
const _14 = "._19pkja5k{margin-top:var(--_kdbk0b)}";
const _13 = "._yyhythi2{grid-column:span 8}";
const _12 = "@media not all and (min-width:64rem){._uoz5uufb{grid-column:span 12}}";
const _11 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _10 = "._yyhyx71z{grid-column:span 4}";
const _9 = "._yv0ecx6w{grid-template-columns:repeat(12,1fr)}";
const _8 = "._1e0c11p5{display:grid}";
const _7 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _6 = "._1wyb1j6v{font-size:1rem}";
const _5 = "._otyroahv{margin-bottom:var(--ds-space-600,3pc)}";
const _4 = "._1bsb1osq{width:100%}";
const _3 = "._1bah1h6o{justify-content:center}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { TabContentContainer } from '../../../AppListing.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._1yt41yrs{padding:0 0 var(--ds-space-800,64x) 0}";
export const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = TabContentContainer,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41yrs", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const MoreReviewsButtonWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  MoreReviewsButtonWrapper.displayName = 'MoreReviewsButtonWrapper';
}
export const UserReviewsWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "section",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _otyroahv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserReviewsWrapper.displayName = 'UserReviewsWrapper';
}
export const SectionMessageText = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wyb1j6v", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SectionMessageText.displayName = 'SectionMessageText';
}
export const ResponsiveContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpxy5q _1e0c11p5 _yv0ecx6w _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ResponsiveContainer.displayName = 'ResponsiveContainer';
}
export const LeftSection = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_yyhyx71z _otyrxy5q _uoz5uufb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LeftSection.displayName = 'LeftSection';
}
export const RightSection = forwardRef((_ref7, __cmplr) => {
  var _cmplp$marginTop;
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  const {
      marginTop
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_kdbk0b": ix((_cmplp$marginTop = __cmplp.marginTop) !== null && _cmplp$marginTop !== void 0 ? _cmplp$marginTop : '5.7rem')
      }),
      ref: __cmplr,
      className: ax(["_yyhythi2 _19pkja5k _uoz5uufb _3wvkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RightSection.displayName = 'RightSection';
}
export const HeadingWrapper = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "header",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeadingWrapper.displayName = 'HeadingWrapper';
}
export const EmptyReviewsWrapper = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qxy5q _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EmptyReviewsWrapper.displayName = 'EmptyReviewsWrapper';
}
export const ErrorWrapper = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxncg _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorWrapper.displayName = 'ErrorWrapper';
}
export const ErrorContentWrapper = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _2, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1b66 _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorContentWrapper.displayName = 'ErrorContentWrapper';
}